<template lang="pug">
  div
    .parallax.mt-6
      v-row(align="center" style="height:100%")
        v-col(cols="12" align="center")
          .display-2.justify-center Partner Ministries
    v-container()
      v-card.pa-8.my-6(dark shaped color="#2d80aa" height="100%" )
        a(href="")
          v-img.float-md-left.mr-4.mb-4.elevation-6( src="../../assets/img/5002617_orig.jpg" width="50%" "min-width"="300" )  
        .display-1 God is Still Speaking
        .body-1 The link 
          a(href="") United Church of Christ (UCC)
          |  is a distinct and diverse community of Christians that come together as one church to join faith and action. With more than 5,100 churches and 1.1 million members across the U.S., the UCC serves God in the co-creation of a just and sustainable world. The UCC is a church of firsts, a church of extravagant welcome, and a church where "…they may all be one" (John 17:21).
      v-card.pa-8.my-6(dark shaped color="#d8252b" height="100%" )
        a(href="")
          v-img.float-md-left.mr-4.mb-4.elevation-6( src="../../assets/img/6261101_orig.jpg" width="50%" "min-width"="300" )  
        .display-1 TFAM The Fellowship of Affirming Ministries
        p.body-1 
          a(href="") The Fellowship of Affirming Ministries
          |  is a multi-denominational group of primarily African American Christian leaders and laity representing churches and faith-based organizations from the USA, Africa, and Mexico.
        p.body-1 These churches range from ultra-conservative backgrounds to more liberal, independent churches; from startup, developing to very large, established churches and from churches that are economically challenged to the very affluent. The overriding purpose of The Fellowship is to support religious leaders and laity in moving toward a theology of radical inclusivity which, by its very nature, requires an equally radical social ministry reaching to the furthest margins of society to serve all in need without prejudice or discrimination.
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../../assets/img/background/1452490739.jpg')
  height 200px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size 100% 90%
  color white
</style>
